import { classNames } from '../../utils/style-class.utils';
export var avatarWrapper = 'rounded-full inline-flex items-center align-middle justify-center font-bold';
export var getAvatarDimensionsBasedOnSizeType = function (avatarSize, displayBorder, borderColor) {
    var borderNormal = "".concat(displayBorder ? "border-2 border-".concat(borderColor) : '');
    var borderLarge = "".concat(displayBorder ? "border-4 border-".concat(borderColor) : '');
    switch (avatarSize) {
        case 'xs':
            return classNames(avatarWrapper, 'h-6 w-6', borderNormal);
        case 'sm':
            return classNames(avatarWrapper, 'h-8 w-8', borderNormal);
        case 'sm-md':
            return classNames(avatarWrapper, 'h-11 w-11', borderNormal);
        case 'md':
        case 'md-lg':
            return classNames(avatarWrapper, 'h-12 w-12', borderLarge);
        case 'header':
            return classNames(avatarWrapper, 'h-120 w-120', borderLarge);
        case 'lg':
        default:
            return classNames(avatarWrapper, 'h-14 w-14', borderLarge);
    }
};
export var getTextType = function (avatarSize) {
    switch (avatarSize) {
        case 'xs':
            return 'help';
        case 'sm':
            return 'h3';
        case 'md':
            return 'h2';
        case 'header':
        case 'lg':
        default:
            return 'h1';
    }
};
export var getIconSize = function (avatarSize) {
    switch (avatarSize) {
        case 'xs':
            return '4';
        case 'sm':
            return '5';
        case 'sm-md':
            return '6';
        case 'md':
            return '8';
        case 'header':
        case 'lg':
        default:
            return '12';
    }
};
//# sourceMappingURL=user-avatar.styles.js.map